import { ASSIGNOTHERMANAGER_SUCCESS, ASSIGNOTHERMANAGER_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const assignOtherManagerReducer = (state = initialState, action) => {
    switch (action.type) {
        case ASSIGNOTHERMANAGER_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case ASSIGNOTHERMANAGER_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: null,
            };
        default:
            break;
    }

    return state;
};

export default assignOtherManagerReducer;
